import { useEffect, useState } from 'react';
import { lambda } from 'src/_shared';
import { usePermission } from 'src/_shared/components/permission-gate/usePermission.js';

function MetabaseDashboardEmbed({ companyId }) {
	const [iFrameUrl, setFrameUrl] = useState();
	const showMetabaseDashboard = usePermission('ui.dashboard.metabase', true);

	useEffect(() => {
		const getReportUrl = async () => {
			const data = await lambda({
				endpoint: 'metabaseEmbeds',
				variables: {
					companyId: companyId,
					reportType: 'dashboard',
					reportId: 13,
				},
			});
			setFrameUrl(data.iframeUrl);
		};
		getReportUrl();
	}, [companyId]);

	return showMetabaseDashboard ? (
		<iframe
			src={iFrameUrl}
			frameBorder="0"
			width={'100%'}
			height={'2500'}
			title="Dashboard"
		/>
	) : null;
}

export default MetabaseDashboardEmbed;
